// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/css/reset.css'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import eruda from 'eruda'

eruda.init();

Vue.config.productionTip = false
Vue.use(MintUI)
window.eventBus = new Vue()

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    this.removeEruda()
  },

  methods: {
    removeEruda() {
      if (eruda) {
        eruda.destroy(); // 销毁Eruda工具
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/main.js